import * as types from './mutation-types'

export default {
  [types.RESET_CONTRACT_DETAIL] (state) {
    state.contract = null
  },
  [types.SET_CONTRACT_DETAIL] (state, c) {
    state.contract = c
  },
  [types.RESET_SEALOUT_DETAIL] (state) {
    state.sealOut = null
  },
  [types.SET_SEALOUT_DETAIL] (state, c) {
    state.sealOut = c
  },
  [types.LIST_INFO_AUDIT] (state, pager) {
    state.auditList.page.list = pager.list
    state.auditList.page.pageNumber = pager.pageNumber
    state.auditList.page.totalPage = pager.totalPage
    state.auditList.page.totalRow = pager.totalRow
    state.auditList.page.firstPage = pager.firstPage
    state.auditList.page.lastPage = pager.lastPage
    state.auditList.page.pageSize = pager.pageSize
  },
  [types.LIST_INFO_CC] (state, pager) {
    state.ccList.page.list = pager.list
    state.ccList.page.pageNumber = pager.pageNumber
    state.ccList.page.totalPage = pager.totalPage
    state.ccList.page.totalRow = pager.totalRow
    state.ccList.page.firstPage = pager.firstPage
    state.ccList.page.lastPage = pager.lastPage
    state.ccList.page.pageSize = pager.pageSize
  },
  [types.LIST_INFO_HISTORY] (state, pager) {
    state.historyList.page.list = pager.list
    state.historyList.page.pageNumber = pager.pageNumber
    state.historyList.page.totalPage = pager.totalPage
    state.historyList.page.totalRow = pager.totalRow
    state.historyList.page.firstPage = pager.firstPage
    state.historyList.page.lastPage = pager.lastPage
    state.historyList.page.pageSize = pager.pageSize
  },
  [types.LIST_INFO_SEAL] (state, pager) {
    state.sealList.page.list = pager.list
    state.sealList.page.pageNumber = pager.pageNumber
    state.sealList.page.totalPage = pager.totalPage
    state.sealList.page.totalRow = pager.totalRow
    state.sealList.page.firstPage = pager.firstPage
    state.sealList.page.lastPage = pager.lastPage
    state.sealList.page.pageSize = pager.pageSize
  },
  [types.LIST_INFO_FILE] (state, pager) {
    state.fileList.page.list = pager.list
    state.fileList.page.pageNumber = pager.pageNumber
    state.fileList.page.totalPage = pager.totalPage
    state.fileList.page.totalRow = pager.totalRow
    state.fileList.page.firstPage = pager.firstPage
    state.fileList.page.lastPage = pager.lastPage
    state.fileList.page.pageSize = pager.pageSize
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js